import React from 'react';
import { motion } from 'framer-motion';
import { Users, Lock, MapPin, CheckCircle2 } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
export function WhyUs() {
  const reasons = [{
    icon: Users,
    pain: "Tired of being passed to offshore teams you can't reach?",
    title: 'Work directly with the engineers building it',
    description: 'Every project is staffed by our in-house Boston team — no subcontractors, no overnight handoffs. The person you talk to is the person writing the code.'
  }, {
    icon: Lock,
    pain: "Stuck with software you can't change or move?",
    title: 'You own everything, on day one',
    description: 'Full source code, IP, infrastructure, and credentials transfer to you from the start. No licensing traps, no platform lock-in — if you ever leave, you take it all.'
  }, {
    icon: MapPin,
    pain: 'Support that disappears after launch?',
    title: 'Long-term local partnership',
    description: 'We stick around. Same timezone, same team, same engineers — so when something breaks or your needs change, you have someone who already knows your system.'
  }, {
    icon: CheckCircle2,
    pain: 'Vague scopes, surprise invoices, missed deadlines?',
    title: 'Transparent process, no surprises',
    description: "Clear scopes, honest timelines, and visible progress every week. You always know what we're working on, what it costs, and where it's headed."
  }];
  return <section className="py-16" data-id="element-167">
      <SectionLabel number="03" label="Why MaytoMation" data-id="element-168" />
      <h2 className="font-display text-4xl md:text-5xl text-ink mb-3 max-w-2xl leading-[1.05]" data-id="element-169">
        Built for the things that{' '}
        <span className="italic text-brand-teal" data-id="element-170">usually go wrong.</span>
      </h2>
      <p className="text-lg text-ink-muted mb-10 max-w-2xl" data-id="element-171">
        Most agencies get tech projects wrong in the same predictable ways. We
        built MaytoMation specifically to fix that.
      </p>
      <div className="grid md:grid-cols-2 gap-6" data-id="element-172">
        {reasons.map((reason, index) => <motion.article key={reason.title} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-surface-paper rounded-2xl p-6 border border-ink/10" data-id="element-173">
            <reason.icon className="w-8 h-8 text-brand-teal mb-4" strokeWidth={1.5} data-id="element-174" />
            <p className="font-display italic text-xl text-brand-deep mb-3 leading-snug" data-id="element-175">
              {reason.pain}
            </p>
            <h3 className="text-base font-bold text-ink mb-2" data-id="element-176">
              {reason.title}
            </h3>
            <p className="text-ink-muted leading-relaxed" data-id="element-177">
              {reason.description}
            </p>
          </motion.article>)}
      </div>
    </section>;
}